import { render, staticRenderFns } from "./CategoryBar.vue?vue&type=template&id=7facc3dc&scoped=true"
import script from "./CategoryBar.vue?vue&type=script&lang=js"
export * from "./CategoryBar.vue?vue&type=script&lang=js"
import style0 from "./CategoryBar.vue?vue&type=style&index=0&id=7facc3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7facc3dc",
  null
  
)

export default component.exports